import React, { useContext, useState } from 'react'
import SettingsSuggestIcon from '@mui/icons-material/SettingsSuggest';
import SearchIcon from '@mui/icons-material/Search';
import Info from './Steps/Info';
import Prem from './Steps/Prem';
import Perehod from './Steps/Perehod';
import { Context } from "../../../Context/LangContext"
function Functions() {
  const { lang } = useContext(Context)
  // information section start
  const [chnageStep, setChangeStep] = useState("ИНФОРМАЦИЯ")
  // information section end
  return (
    <section id='function' className='bg-[#6F42C1] py-20'>
      <div className='container mx-auto px-2'>
        <div className='max-w-[490px] mx-auto'>
          <h2 className='text-[30px] sm:text-[40px] font-bold text-white text-center mb-2'>{lang ? "FUNSIYALAR" : "ФУНКЦИИ"}</h2>
          <p className='text-white text-[14px] sm:text-[18px] text-center'>
            {lang ? "CASHBOX - cheksiz imkoniyatlarga ega ixcham onlayn kassa: kassa + bank terminali. Ham oflayn, ham onlayn rejimlarda ishlaydi." : "CASHBOX – компактная онлайн-касса с неограниченными возможностями: контрольно-кассовая машина + банковский терминал. Работает как в офлайн, так и в онлайн режимах."}
          </p>
        </div>
        <div className='mt-16'>
          <ul className='text-white mb-16 font-semibold flex-col flex sm:flex-row  items-center justify-center'>
            <li onClick={() => setChangeStep("ИНФОРМАЦИЯ")} className={`flex cursor-pointer items-center space-x-1 px-5 py-2 border-b-2 ${chnageStep === "ИНФОРМАЦИЯ" ? "border-[#00C9DB] text-[#00C9DB]" : ""}`}>
              <SettingsSuggestIcon />
              <span>{lang ? "MA'LUMOTLAR" : "ИНФОРМАЦИЯ"}</span>
            </li>
            <li onClick={() => setChangeStep("ПРЕИМУЩЕСТВА")} className={`flex cursor-pointer items-center space-x-1 px-5 py-2 border-b-2  ${chnageStep === "ПРЕИМУЩЕСТВА" ? "border-[#00C9DB] text-[#00C9DB]" : ""}`}>
              <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-binoculars-fill" viewBox="0 0 16 16">
                <path d="M4.5 1A1.5 1.5 0 0 0 3 2.5V3h4v-.5A1.5 1.5 0 0 0 5.5 1h-1zM7 4v1h2V4h4v.882a.5.5 0 0 0 .276.447l.895.447A1.5 1.5 0 0 1 15 7.118V13H9v-1.5a.5.5 0 0 1 .146-.354l.854-.853V9.5a.5.5 0 0 0-.5-.5h-3a.5.5 0 0 0-.5.5v.793l.854.853A.5.5 0 0 1 7 11.5V13H1V7.118a1.5 1.5 0 0 1 .83-1.342l.894-.447A.5.5 0 0 0 3 4.882V4h4zM1 14v.5A1.5 1.5 0 0 0 2.5 16h3A1.5 1.5 0 0 0 7 14.5V14H1zm8 0v.5a1.5 1.5 0 0 0 1.5 1.5h3a1.5 1.5 0 0 0 1.5-1.5V14H9zm4-11H9v-.5A1.5 1.5 0 0 1 10.5 1h1A1.5 1.5 0 0 1 13 2.5V3z" />
              </svg>
              <span>{lang ? "AFZALIKLAR" : "ПРЕИМУЩЕСТВА"}</span>
            </li>
            <li onClick={() => setChangeStep("КОМУ ПОДХОДИТ")} className={`flex cursor-pointer items-center space-x-1 px-5 py-2 border-b-2  ${chnageStep === "КОМУ ПОДХОДИТ" ? "border-[#00C9DB] text-[#00C9DB]" : ""}`}>
              <SearchIcon />
              <span>{lang ? "KIMLAR UCHUN" : "КОМУ ПОДХОДИТ"}</span>
            </li>
          </ul>
          {chnageStep === "ИНФОРМАЦИЯ" && <Info />}
          {chnageStep === "ПРЕИМУЩЕСТВА" && <Prem />}
          {chnageStep === "КОМУ ПОДХОДИТ" && <Perehod />}
        </div>
      </div>
    </section>
  )
}

export default Functions